import React from 'react';
import './LegalPage.css';

const PrivacyPage = () => (
  <div className="legal-page">
    <h1>Privacy Policy</h1>
    <p className="legal-updated">Last updated: 8 October 2026</p>

    <p>
      Irish Visa Tracker ("we", "us", "the Service") is an independent
      monitoring service operated by SelfDriven Careers. This page explains
      what information we collect, how we use it, and how you can ask us to
      delete it.
    </p>

    <h2>1. What we collect</h2>
    <ul>
      <li>Name, email address and phone number — collected during checkout for your account and service support. Email is used for alerts and access recovery.</li>
      <li>Visa reference numbers — needed to match your record in the daily NDVO publication.</li>
      <li>Payment metadata and gateway responses — used to verify purchases and support payment enquiries. Payments are processed by PayU; we do not collect full card details through our checkout form.</li>
      <li>Browser localStorage and sessionStorage — used for theme, premium session, and notification preferences. Enrolled push endpoints and delivery receipts are stored to operate browser notifications.</li>
    </ul>

    <h2>2. What we do not collect</h2>
    <ul>
      <li>Passport numbers or scans.</li>
      <li>Biometric data.</li>
      <li>Full payment card details (handled by PayU).</li>
      <li>Tracking data for advertising purposes.</li>
    </ul>

    <h2>3. How we use your data</h2>
    <p>
      We use your email and reference numbers solely to deliver the alerts
      and tools you signed up for. We do not sell, rent, or share your data
      with third parties for marketing.
    </p>
    <p>
      With the user's permission, rotating activity cards may show a first
      initial with a blurred placeholder for the rest of the name, city, visa
      category, decision status and a masked reference number. User-provided
      cards retain their captured relative-time labels; snapshot-date display
      follows the site owner's choice. The current cards do not show a date,
      and their relative times are not live elapsed times. Full names, contact
      details and full visa references are not displayed. Activity cards are
      not proof that an alert was delivered.
    </p>

    <h2>4. Where your data is stored</h2>
    <p>
      Account profiles and follow-up schedules are stored in Firebase Firestore.
      Payment records, monitored references, notification jobs and browser-push subscriptions are stored in Supabase.
      Resend processes email delivery. Browser-push providers process notifications for enrolled devices.
    </p>

    <h2>5. Cookies and analytics</h2>
    <p>
      We use Google Analytics 4 in consent mode. Analytics are off by default
      and only enabled after you click "Accept" on the cookie banner. No
      advertising cookies are set.
    </p>

    <h2>6. Your rights</h2>
    <ul>
      <li><strong>Access</strong> — email us for a copy of the data we hold on you.</li>
      <li><strong>Correction</strong> — email us to correct any incorrect data.</li>
      <li><strong>Deletion</strong> — see our <a href="/data-deletion">Data Deletion</a> page.</li>
    </ul>

    <h2>7. Contact</h2>
    <p>
      For privacy questions, email{' '}
      <a href="mailto:visahelp@irelandvisatracker.in">visahelp@irelandvisatracker.in</a>.
    </p>
  </div>
);

export default PrivacyPage;
